import apiBankingTransactions from "../../api/apiBankingTransactions";
import apiProformaInvoices from "../../api/apiProformaInvoices";

const state = {
    alertMessage: "",
    unpaidInvoices: [],
    allTransactions: [],
    originalTransactions: [],
    transactionTotals: {
        deposit: 0,
        receivables: 0,
        moneyIn: 0,
        moneyOut: 0,
        payment: 0,
        subTotal: 0,
        currency: 1,
        refund_amount: 0
    },
    clientTransactionTotals: {
        deposit: 0,
        moneyIn: 0,
        moneyOut: 0,
        payment: 0,
        subTotal: 0,
        currency: 1
    },
    transactionFields: {
        client_id: '',
        amount: '',
        type: '',
        transaction_date: '',
        description: '',
    },
    query: {
        order: 1,
        orderBy: 'id',
        search: '',
        dateFrom: '',
        dateTo: '',
        client: '',
        page: 1,
        lastPage: null,
        firstPage: 1,
    },
    transDeleteModal: false,
    transactionDeleteId: '',
    transactionType: '',
    amount_used: 0,
    transactionInvoices: [],
    transactionMultiInvoices: [],
    refundAmount: [],
    customerPayment: '',
    openModal: '',
    openReceivableModal: '',
    openPaidAmountModal: '',
    clientDeposits: [],
    receivables: [],
    openMultiInvoice: false,
    multi_invoice_id: '',
    invoices: [],
    unpaid_invoices: [],

}
const mutations = {
    setQueryClient: (state, clientId) => {
        state.query.client = clientId;
    },
    setTransactionStatus: (state, message) => {
        state.alertMessage = message
    },
    setTransactionTotals: (state, totals) => {
        state.transactionTotals = totals
    },
    setClientTransactionTotals: (state, totals) => {
        state.clientTransactionTotals = totals
    },
    setTransactionClient: (state, data) => {
        state.transactionFields.client_id = data
    },
    setTransactionAmount: (state, data) => {
        state.transactionFields.amount = data
    },
    setTransactionType: (state, data) => {
        state.transactionFields.type = data
    },
    setTransactionDate: (state, data) => {
        state.transactionFields.transaction_date = data
    },
    setTransactionDescription: (state, data) => {
        state.transactionFields.description = data
    },
    setTransactionAmountUsed: (state, data) => {
        state.transactionFields.amount_used = data
    },
    setTransactionUnusedAmount: (state, data) => {
        state.transactionFields.unsed_amount = data
    },
    setTransactionRefundAmount: (state, data) => {
        state.transactionFields.refund_amount = data
    },
    setUnpaidInvoices: (state, data) => {
        state.unpaidInvoices = data
    },
    setAllTransactions: (state, data) => {
        state.allTransactions = data
    },
    setOriginalTransactions: (state, data) => {
        state.originalTransactions = data
    },
    setOrderByTransactions: (state, data) => {
        state.query.order = data.order;
        state.query.orderBy = data.orderBy;
    },
    setFilterTransactions: (state, data) => {
        state.query.client = data.client;
        state.query.search = data.search;
        state.query.dateFrom = data.dateFrom;
        state.query.dateTo = data.dateTo;
    },
    setTransactionCurrentPage: function (state, currentPage) {
        state.query.page = currentPage
    },
    setTransactionLastPage: function (state, lastPage) {
        state.query.lastPage = lastPage
    },
    setTransactionDeleteModalStatus: function (state, newStatus) {
        state.transDeleteModal = newStatus;
    },
    setTransactionDeleteId: function (state, transactionId) {
        state.transactionDeleteId = transactionId;
    },
    setBTransactionType: function (state, type) {
        state.transactionType = type;
    },
    setAmountUsed: function (state, amount_used) {
        state.amount_used += amount_used;
    },
    resetInvoiceAmountUsed: function (state) {
        state.transactionInvoices = [];
    },
    resetMultiInvoiceAmountUsed: function (state) {
        state.transactionMultiInvoices = [];
    },
    setInvoiceAmountUsed: function (state, invObj) {
        let newInvoice = true
        state.transactionInvoices.forEach((inv) => {
                if (inv.invoice_id == invObj.invoice_id) {
                    inv.amount_used = Number(invObj.amount_used)
                    inv.deposit = invObj.deposit
                    newInvoice = false
                }
            }
        )
        if (newInvoice) {
            state.transactionInvoices.push(invObj);
        }
    },
    setMultiInvoiceAmountUsed: function (state, invObj) {
        let newInvoice = true
        state.transactionMultiInvoices.forEach((inv) => {
                if (inv.id == invObj.id) {
                    inv.amount_used = Number(invObj.amount_used)
                    inv.deposit = invObj.deposit
                    newInvoice = false
                }
            }
        )
        if (newInvoice) {
            state.transactionMultiInvoices.push(invObj);
        }
    },
    setCurrentRefundAmount: function (state, data) {
        state.refundAmount = data
    },
    setCustomerPayment: function (state, data) {
        state.customerPayment = data
    },
    setClientDepositModalStatus: function (state, newStatus) {
        state.openModal = newStatus;
    },
    setReceivablesModalStatus: function (state, newStatus) {
        state.openReceivableModal = newStatus;
    },
    setPaidAmountModalStatus: function (state, newStatus) {
        state.openPaidAmountModal = newStatus;
    },
    setClientDeposits: function (state, data) {
        state.clientDeposits = data
    },
    setReceivables: function (state, data) {
        state.receivables = data
    },
    setPaidAmount: function (state, data) {
        state.paidAmount = data
    },
    setMultiInvoicesModal: function (state, newStatus) {
        state.openMultiInvoice = newStatus;
    },
    setCurrentMultiInvoice: function (state, data) {
        state.multi_invoice_id = data.multi_invoice_id;
        state.invoices = data.invoices;
    },
    setUnpaidAllInvoices: function (state, invoices) {
        state.unpaid_invoices = invoices
    },
    updateUnpaidAllInvoices: function (state, invoice) {
        state.unpaid_invoices.forEach((inv, ind) => {
            if (invoice.id == inv.id) {
                state.unpaid_invoices[ind] = invoice
            }
        })
    }
}
const getters = {
    getTransactionStatus: (state) => {
        return state.alertMessage
    },
    getTransactionTotals: (state) => {
        return state.transactionTotals
    },
    getClientTransactionTotals: (state) => {
        return state.clientTransactionTotals
    },
    getTransactionClient: (state) => {
        return state.transactionFields.client_id
    },
    getTransactionAmount: (state) => {
        return state.transactionFields.amount
    },
    getTransactionType: (state) => {
        return state.transactionFields.type
    },
    getTransactionDate: (state) => {
        return state.transactionFields.transaction_date
    },
    getTransactionDescription: (state) => {
        return state.transactionFields.description
    },
    getTransactionAmountUsed: (state, data) => {
        return state.transactionFields.amount_used
    },
    getTransactionUnusedAmount: (state, data) => {
        return state.transactionFields.unsed_amount
    },
    getTransactionRefundAmount: (state, data) => {
        return state.transactionFields.refund_amount
    },
    getUnpaidInvoices: (state) => {
        return state.unpaidInvoices
    },
    getAllTransactions: (state) => {
        return state.allTransactions
    },
    getOriginalTransactions: (state) => {
        return state.originalTransactions
    },
    getTransactionCurrentPage: function (state) {
        return state.query.page
    },
    getTransactionFirstPage: (state) => {
        return state.query.firstPage
    },
    getTransactionLastPage: (state) => {
        return state.query.lastPage
    },
    getTransactionId: (state) => {
        return state.transactionDeleteId;
    },
    getBTransactionType: (state) => {
        return state.transactionType;
    },
    getTransactionDeleteModalStatus: (state) => {
        return state.transDeleteModal;
    },
    getAmountUsed: function (state) {
        return state.amount_used;
    },
    getInvoiceAmountUsed: function (state) {
        return state.transactionInvoices;
    },
    getMultiInvoiceAmountUsed: function (state) {
        return state.transactionMultiInvoices;
    },
    getCurrentRefundAmount: function (state) {
        return state.refundAmount;
    },
    getCustomerPayment: function (state, data) {
        return state.customerPayment
    },
    getClientDepositModalStatus: function (state) {
        return state.openModal;
    },
    getReceivablesModalStatus: function (state) {
        return state.openReceivableModal;
    },
    getPaidAmountModalStatus: function (state) {
        return state.openPaidAmountModal;
    },
    getClientDeposits: function (state) {
        return state.clientDeposits
    },
    getReceivables: function (state) {
        return state.receivables
    },
    getPaidAmount: function (state) {
        return state.paidAmount
    },
    getMultiInvoicesModal: function (state) {
        return state.openMultiInvoice;
    },
    getCurrentMultiInvoiceId: function (state) {
        return state.multi_invoice_id;
    },
    getCurrentMultiInvoices: function (state) {
        return state.invoices;
    },
    getUnpaidAllInvoices: function (state) {
        return state.unpaid_invoices;
    }
}
const actions = {
    createBankingTransaction: ({ state, dispatch, commit }, data) => {
        apiBankingTransactions
            .createBankingTransaction(data)
            .then((response) => {
                commit('setTransactionStatus', response.data ? "Transaction created successfully" : "Something went wrong")
                dispatch('getTransactionTotals', data.client_id)
            })
            .catch((error) => console.log(error))
    },
    createMoneyOutTransaction: ({ state, dispatch, commit }, data) => {
        apiBankingTransactions
            .createMoneyOutTransaction(data)
            .then((response) => {
                commit('setTransactionStatus', response.data ? "Transaction created successfully" : "Something went wrong")
                dispatch('getTransactionTotals', data.client_id)
            })
            .catch((error) => console.log(error))
    },
    editBankingTransaction: ({ state, dispatch, commit }, data) => {
        apiBankingTransactions
            .editBankingTransaction(data.data, data.id)
            .then((response) => {
                commit('setTransactionStatus', response.data ? "Transaction edited successfully" : "Something went wrong")
                dispatch('getTransactionTotals', data.data.client_id)
            })
            .catch((error) => console.log(error))
    },
    editRefundTransaction: ({ state, dispatch, commit }, data) => {
        apiBankingTransactions
            .editRefundTransaction(data.data, data.id)
            .then((response) => {
                commit('setTransactionStatus', response.data ? "Transaction edited successfully" : "Something went wrong")
            })
            .catch((error) => console.log(error))
    },
    getTransactionTotals: ({ commit }, userId) => {
        apiBankingTransactions
            .getTransactionTotals(userId)
            .then((response) => {
                commit('setTransactionTotals', response.data)
            })
    },
    getClientTransactionTotals: ({ commit }, userId) => {
        if (userId) {
            apiBankingTransactions
                .getTransactionTotals(userId)
                .then((response) => {
                    commit('setClientTransactionTotals', response.data)
                })
        } else {
            apiBankingTransactions
                .getClientTransactionTotals()
                .then((response) => {
                    commit('setClientTransactionTotals', response.data)
                })
        }
    },
    getUserTransactionTotals: ({ commit }) => {
        apiBankingTransactions
            .getClientTransactionTotals()
            .then((response) => {
                commit('setClientTransactionTotals', response.data)
            })
    },
    getTransaction: ({ commit, dispatch }, id) => {
        dispatch('setStatusLoading')
        apiBankingTransactions
            .getTransaction(id)
            .then((response) => {
                commit('setTransactionClient', response.data.client_id)
                commit('setTransactionAmount', response.data.amount)
                commit('setTransactionType', response.data.type)
                commit('setTransactionDate', response.data.transaction_date)
                commit('setTransactionDescription', response.data.description)
                commit('setTransactionAmountUsed', response.data.amount_used)
                commit('setTransactionUnusedAmount', response.data.unused_amount)
                commit('setTransactionRefundAmount', response.data.refund_amount)
                commit('setUnpaidInvoices', response.data.unpaidInvoices);
                response.data.unpaidInvoices.invoices.forEach((invoice) => {
                    commit('setInvoiceAmountUsed', { 'invoice_id': invoice.id, 'amount_used': invoice.amount_used, 'deposit': invoice.deposit })
                })
                dispatch('setStatusLoaded')
                let userId = response.data.client_id;
                dispatch('getTransactionTotals', userId)
            })
    },
    getRefundTransaction: ({ commit, dispatch }, id) => {
        dispatch('setStatusLoading')
        apiBankingTransactions
            .getRefundTransaction(id)
            .then((response) => {
                commit('setTransactionClient', response.data.client_id)
                commit('setTransactionAmount', response.data.amount)
                commit('setTransactionType', response.data.type)
                commit('setTransactionDate', response.data.transaction_date)
                commit('setTransactionDescription', response.data.description)

                commit('setCustomerPayment', response.data.customer_payment);
                dispatch('setStatusLoaded')
            })
    },
    getTransactionsAction: ({ commit, state }) => {
        apiBankingTransactions
            .getAllTransactions(state.query)
            .then((response) => {
                commit('setAllTransactions', response.data.data);
                commit('setOriginalTransactions', response.data.data);
                commit('setTransactionLastPage', response.data.last_page);
                //this.all_transactions = response.data;
            })
    },
    getClientTransactionsAction: ({ commit, state }, userId) => {
        apiBankingTransactions
            .getAllTransactions(state.query)
            .then((response) => {
                commit('setAllTransactions', response.data.data);
                commit('setOriginalTransactions', response.data.data);
                commit('setTransactionLastPage', response.data.last_page);
                //this.all_transactions = response.data;
            })
    },
    paymentDepositInvoice: ({ commit }, data) => {
        apiBankingTransactions
            .paymentDepositInvoice(data)
            .then((response) => {

            })
    },
    deleteTransactionById: ({ commit, dispatch }, data) => {
        apiBankingTransactions
            .deleteTransactionById(data)
            .then((response) => {
                if (response.data.success) {
                    commit('setTransactionDeleteModalStatus', false)
                    commit('setTransactionDeleteId', '')
                    commit('setBTransactionType', '')
                    dispatch('getTransactionsAction')
                }
            })
    },
    fetchClientDeposits: ({ commit }, user) => {
        apiBankingTransactions
            .fetchClientDeposits(user)
            .then((response) => {
                if (response.data) {
                    commit('setClientDeposits', response.data)
                }
            })
    },
    fetchReceivables: ({ commit }, user) => {
        apiBankingTransactions
            .fetchReceivables(user)
            .then((response) => {
                if (response.data) {
                    commit('setReceivables', response.data)
                }
            })
    },
    fetchPaidAmount: ({ commit }, user) => {
        apiBankingTransactions
            .fetchPaidAmount(user)
            .then((response) => {
                if (response.data) {
                    commit('setPaidAmount', response.data)
                }
            })
    }
}

export default { actions, mutations, getters, state }


// WEBPACK FOOTER //
// ./src/store/modules/bankingTransaction.js